if (!window.Eurus.loadedScript.has('scrolling-promotion.js')) {
  window.Eurus.loadedScript.add('scrolling-promotion.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xScrollPromotion', () => ({
        animationFrameId: null,
        window_height: window.innerHeight,
        init() {
          const container = this.$el.getElementsByClassName('scrolling-container')[0];
          if (container) {
            this.initDragScroll(container, this.$el);
          }
        },
        load(el) {
          const container = el.getElementsByClassName('scrolling-container')[0];
          const item = container.getElementsByClassName('el_animate')[0];

          container.style.overflowX = 'auto';
          container.style.scrollbarWidth = 'none';
          container.style.msOverflowStyle = 'none';
          container.style.touchAction = 'pan-x';
          container.style.webkitOverflowScrolling = 'touch';

          if (!document.getElementById('hide-scroll-css')) {
            const style = document.createElement('style');
            style.id = 'hide-scroll-css';
            style.innerHTML = '.scrolling-container::-webkit-scrollbar { display: none; }';
            document.head.appendChild(style);
          }

          const frag = document.createDocumentFragment();

          // Render 3 complete copies in total (1 original + 2 clones)
          for (let i = 0; i < 2; i++) {
            const clone = item.cloneNode(true);
            frag.appendChild(clone);
          }
          container.appendChild(frag);

          requestAnimationFrame(() => {
            const itemWidth = item.offsetWidth;
            // Position the scroll in the middle copy
            container.scrollLeft = itemWidth;
            this.initDragScroll(container, el, item);
          });
        },

        initDragScroll(container, sectionEl, item) {
  // VALIDACIÓN INICIAL: Si los elementos esenciales no existen, salir de la función
  if (!container || !item) {
    console.warn("initDragScroll: 'container' o 'item' no encontrados.");
    return;
  }

  container.addEventListener('scroll', () => {
    // Verificamos que item exista antes de pedir su offsetWidth
    if (!item) return;
    
    const itemWidth = item.offsetWidth;
    if (itemWidth === 0) return;

    if (container.scrollLeft <= 0) {
      container.scrollLeft += itemWidth;
    } else if (container.scrollLeft >= itemWidth * 2) {
      container.scrollLeft -= itemWidth;
    }
  });

  let isDragging = false;
  let startX;
  let scrollLeft;

  container.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
    if (sectionEl) sectionEl.style.userSelect = 'none';
  });

  const endDrag = () => {
    if (isDragging) {
      isDragging = false;
      if (sectionEl) sectionEl.style.userSelect = '';
    }
  };

  container.addEventListener('mouseleave', endDrag);
  container.addEventListener('mouseup', endDrag);

  container.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();

    const currentX = e.pageX;
    const x = currentX - container.offsetLeft;
    const walk = (x - startX) * 1.5;
    container.scrollLeft = scrollLeft - walk;
  });

  container.addEventListener('dragstart', (e) => {
    e.preventDefault();
  });

  // Touch support for mobile
  let isTouching = false;

  container.addEventListener('touchstart', () => {
    isTouching = true;
    isDragging = true;
    exactScrollLeft = container.scrollLeft;
    lastTime = performance.now();
  }, { passive: true });

  container.addEventListener('touchend', () => {
    isTouching = false;
    // Don't resume here — wait for vertical page scroll
  }, { passive: true });

  container.addEventListener('touchcancel', () => {
    isTouching = false;
    // Don't resume here — wait for vertical page scroll
  }, { passive: true });

  // Resume auto-scroll only when the user scrolls the page vertically
  const resumeOnPageScroll = () => {
    if (!isTouching) {
      isDragging = false;
      lastTime = performance.now();
      exactScrollLeft = container.scrollLeft;
    }
  };
  window.addEventListener('scroll', resumeOnPageScroll, { passive: true });

  container.style.scrollBehavior = 'auto';

  // --- Auto Scroll (Marquee) ---
  const durStr = sectionEl ? getComputedStyle(sectionEl).getPropertyValue('--duration').trim() : '20s';
  const duration = parseFloat(durStr) || 20;
  const isReverse = sectionEl ? getComputedStyle(sectionEl).getPropertyValue('--direction').trim() === 'reverse' : false;

  let autoScrollRaf = null;
  let exactScrollLeft = container.scrollLeft;
  let lastTime = performance.now();
  let isHovered = false;

  const playAutoScroll = () => {
    const now = performance.now();
    const dt = now - lastTime;
    lastTime = now;

    // Solo auto-scroll si item existe
    if (!isDragging && !isHovered && item) {
      const itemWidth = item.offsetWidth;
      if (itemWidth > 0 && duration > 0) {
        const pixelsPerSec = itemWidth / duration;
        const delta = (pixelsPerSec * dt) / 1000;

        exactScrollLeft += isReverse ? -delta : delta;

        const integerScroll = Math.floor(exactScrollLeft);
        if (Math.abs(container.scrollLeft - integerScroll) > 0) {
          container.scrollLeft = integerScroll;
        }
      }
    } else {
      exactScrollLeft = container.scrollLeft;
    }
    autoScrollRaf = requestAnimationFrame(playAutoScroll);
  };

  window.addEventListener('scroll', () => {
    if (!autoScrollRaf) {
      lastTime = performance.now();
      autoScrollRaf = requestAnimationFrame(playAutoScroll);
    }
  }, { once: true, passive: true });

  if (sectionEl) {
    sectionEl.addEventListener('mouseenter', () => {
      isHovered = true;
    });
    sectionEl.addEventListener('mouseleave', () => {
      isHovered = false;
      lastTime = performance.now();
      exactScrollLeft = container.scrollLeft;
    });
  }
},

        createObserver(el, rtlCheck = false) {
          const option = {
            root: null,
            rootMargin: '300px',
            threshold: 0
          };

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.updateRotation(el, rtlCheck)
              } else {
                if (this.animationFrameId) {
                  cancelAnimationFrame(this.animationFrameId);
                  this.animationFrameId = null;
                }
              }
            });
          }, option);

          observer.observe(el);
        },

        updateRotation(el, rtlCheck = false) {
          const update = () => {
            const element = el.firstElementChild;
            if (!element) return;

            const element_rect = element.getBoundingClientRect();
            const element_height = element_rect.top + element_rect.height / 2;
            let value;

            if (element_height > -200 && element_height < this.window_height + 200) {
              value = Math.max(Math.min((((element_height / this.window_height) * 10) - 5), 5), -5);
              if (rtlCheck) value *= -1;
              element.style.transform = `rotate(${value}deg) translateX(-20px)`;
            }

            this.animationFrameId = window.requestAnimationFrame(update);
          }

          if (!this.animationFrameId) {
            update();
          }
        },
      }));
    })
  });
}
